import React, {Component} from "react"

class DialogBox extends Component {
    render() {
        return (
            <div className={"dialogBoxContainer "+this.props.theme}>
                <div className="dialogBox">
                    {this.props.title && <h2 style={{textAlign: "center", marginTop: "0", marginBottom: "0.5rem", display: "block"}}>{this.props.title}</h2>}
                    {this.props.message && <p style={{textAlign: "center"}} dangerouslySetInnerHTML={{__html: this.props.message}}/>}

                    <div className="buttons">
                        { this.props.btn1Text && <button type="button" className={"btn "+(this.props.btn1Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn1Title); }}>{this.props.btn1Text}</button> }
                        { this.props.btn2Text && <button type="button" className={"btn "+(this.props.btn2Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn2Title); }}>{this.props.btn2Text}</button> }
                        { this.props.btn3Text && <button type="button" className={"btn "+(this.props.btn3Theme || '')} onClick={() => { this.props.response && this.props.response(this.props.btn3Title); }}>{this.props.btn3Text}</button> }
                    </div>
                </div>
                <div style={{left: "0", zIndex: "1031"}} onClick={() => { this.props.response && this.props.response("dismiss"); }} className="dark-overlay"></div>
            </div>

        )
    }
}

export default DialogBox